import * as types from "./mutation-type";

export default {
    [types.SET_DELIVERY_TIME](state, payload) {
        state.deliveryTime = payload;
    },

    [types.SET_OPEN_CALENDAR](state, payload) {
        state.openCalendar = payload;
    },

    [types.SET_CLOSE_MODAL_CALENDAR](state, payload) {
        state.closeModalCalendar = payload;
    }
};
